import axios from "axios";
import { attachAppAgent } from "@/api/appAgent";

let instance = axios.create({
  baseURL: process.env.BASE_URL + "/api/v2/stv",
  timeout: 10000,
  withCredentials: false,
});

let instanceWithCookie = axios.create({
  baseURL: process.env.BASE_URL + "/api/v2/stv",
  timeout: 10000,
  withCredentials: true,
});

attachAppAgent(instance);
attachAppAgent(instanceWithCookie);

// let instanceWithCookieV3 = axios.create({
//   baseURL: process.env.BASE_URL + "/api/v3/stv",
//   timeout: 10000,
//   withCredentials: true,
// });

// let newInstance = axios.create({
//   baseURL: `${process.env.VUE_APP_BITMOVIN_BASE_URL}/api/v3/stv`,
//   timeout: 10000,
//   withCredentials: false,
// });

const api = {
  splash: "/splash",
  homeData: "/home/web",
  homeHash: "/home/hash", // 홈데이터 변경사항 체크를 위해 hash값 비교
  gameType: "/game/type",
  leagueByTypeId: "/league/", // + typeId
  leagueByLeagueId: "/game/league/", // + leagueId
  season: "/season/", // + leagueId + /year
  year: "/year/", // + leagueId  (종합격투기만)
  entry: "/entry/", // + seasonId
  round: "/round/", // + seasonId
  lives: "/lives/", // + date
  leagueVodList: "/vod/league/detail",
  leagueRoundVodList: "/vod/league/detail/round",
  gameVodList: "/vod/game",
  programList: "/origin/home/web",
  programDetail: "/origin/",
  themeDetail: "/theme/",
  systemPopup: "/popup",
  login: "/login",
  deviceVerify: "/device/verify",
  registDevice: "/device/register",
  extendOtpTime: "/device/ext/lifetime",
  userSubscription: "/user/sub", // user/sub/scope와 동일함
  terms: "/terms/", // + 약관ID (0 = 전체)
  logout: "/logout",
  session: "/session",
  topBanner: "/top",
  vodData: "/vod/",
  liveData: "/live/di/con/sec/stv/",
  live: "/live/",
  userAccess: "/user/subscription/access",
  contentsPermission: "/user/permissions/contents",
  services: "/user/permissions/services",
};

function setBaseUrl(url) {
  instanceWithCookie.defaults.baseURL = url + "/api/v2/stv";
  instance.defaults.baseURL = url + "/api/v2/stv";
}

function fetchSplash() {
  return instance.get(api.splash);
}

function fetchHomeData() {
  return instance.get(api.homeData);
}

function fetchHomeHash() {
  return instance.get(api.homeHash);
}

function fetchGameType() {
  return instance.get(api.gameType);
}

function fetchLeagueByTypeId(typeId) {
  const url = `${api.leagueByTypeId}${typeId}`;
  return instance.get(url);
}

function fetchLeagueByLeagueId(leagueId) {
  const url = `${api.leagueByLeagueId}${leagueId}`;
  return instance.get(url);
}

function fetchSeasonByLeagueId(leagueId) {
  const url = `${api.season}${leagueId}`;
  return instance.get(url);
}

function fetchSeasonByYear(leagueId, year) {
  const url = `${api.season}${leagueId}${year}`;
  return instance.get(url);
}

function fetchYearByLeagueId(leagueId) {
  const url = `${api.year}${leagueId}`;
  return instance.get(url);
}

function fetchEntry(seasonId) {
  const url = `${api.entry}${seasonId}`;
  return instance.get(url);
}

function fetchRound(seasonId) {
  const url = `${api.round}${seasonId}`;
  return instance.get(url);
}

function fetchLives(date) {
  const url = `${api.lives}${date}`;
  return instance.get(url);
}
function fetchLeagueVodList(params) {
  return instance.get(api.leagueVodList, { params });
}

function fetchLeagueRoundVodList(params) {
  return instance.get(api.leagueRoundVodList, { params });
}

function fetchGameVodList(params) {
  return instance.get(api.gameVodList, { params });
}

function fetchProgramList() {
  return instance.get(api.programList);
}
function fetchProgramDetailList(programId, params) {
  return instance.get(`${api.programDetail}${programId}` + "/list", { params });
}

function fetchProgramInfo(programId) {
  return instance.get(`${api.programDetail}${programId}`);
}

function fetchThemeDetailList(themeId, params) {
  return instance.get(`${api.themeDetail}${themeId}` + "/list", { params });
}
function fetchThemeInfo(themeId) {
  return instance.get(`${api.themeDetail}${themeId}`);
}
function fetchSystemPopup() {
  return instance.get(api.systemPopup);
}

function registDevice(data) {
  return instance.put(api.registDevice, data);
}

function extendOtpTime(params) {
  return instance.get(api.extendOtpTime, { params });
}

function deviceVerify(params) {
  return instance.get(api.deviceVerify, { params });
}

function login(data) {
  return instanceWithCookie.post(api.login, data);
}

function fetchUserSubscription() {
  return instanceWithCookie.get(api.userAccess);
}

function fetchContentsPermission(params) {
  return instanceWithCookie.get(api.contentsPermission, { params });
}

function fetchServices(params) {
  return instanceWithCookie.get(api.services, { params });
}

function fetchTerms(termId) {
  const url = `${api.terms}${termId}`;
  return instance.get(url);
}

function logout() {
  return instanceWithCookie.get(api.logout);
}

function getSession() {
  return instanceWithCookie.get(api.session);
}

function postSession() {
  return instanceWithCookie.post(api.session);
}

// function checkSession() {
//   return instanceWithCookie.get(api.session);
// }

function fetchTopBanner() {
  return instance.get(api.topBanner);
}

function fetchVodData(id) {
  const url = `${api.vodData}${id}`;
  return instance.get(url);
}

function fetchLiveData(id) {
  const url = `${api.live}${id}`;
  return instance.get(url);

  // v3 Drm 적용 시 사용
  // const url = `${api.liveData}${id}`;
  // return instance.get(url);
}

function sendViewLog(url, data) {
  return instance.post(url, data);
}

export {
  setBaseUrl,
  fetchSplash,
  fetchHomeData,
  fetchHomeHash,
  fetchGameType,
  fetchLeagueByTypeId,
  fetchLeagueByLeagueId,
  fetchSeasonByLeagueId,
  fetchSeasonByYear,
  fetchYearByLeagueId,
  fetchEntry,
  fetchRound,
  fetchLives,
  fetchLeagueVodList,
  fetchLeagueRoundVodList,
  fetchGameVodList,
  fetchProgramList,
  fetchProgramInfo,
  fetchProgramDetailList,
  fetchThemeInfo,
  fetchThemeDetailList,
  fetchSystemPopup,
  login,
  logout,
  getSession,
  postSession,
  // checkSession,
  deviceVerify,
  registDevice,
  extendOtpTime,
  fetchUserSubscription,
  fetchTerms,
  fetchTopBanner,
  fetchVodData,
  fetchLiveData,
  sendViewLog,
  fetchContentsPermission,
  fetchServices,
};
